/**
 * A packaged item no allowed container has room for.
 *
 * The menu is misconfigured: the backend demands packaging for this item
 * (some container allows it), but every such container is smaller than the
 * item, so the order will be rejected as InvalidPackagingAssignment.
 */
export class UnpackableItemError extends Error {
    constructor(item) {
        super(`No allowed packaging container fits ${item.subject.type} ${item.id.toString()} of volume ${item.productVolume.value.toString()}`);
        this.name = "UnpackableItemError";
    }
}
